/**
 * @todo
 * - Evaluate template query improvement.
 *
 * @module
 */
import { closestAttribute, queryInTemplates } from "@acng/frontend-bounty/dom/query.js";
import { onClickElement } from "@acng/frontend-bounty/dom/event.js";
import { after, createComment, replace } from "@acng/frontend-bounty";
import { popup } from "./context.js";
const MODULE = "discovery/dropdown";
/**
 * @example
 * ```js
 * // Register Stargazer Controller
 * stargazer.controller('dropdown', {[construct]: createDropdown});
 *
 * // Register Custom Element
 * window.customElements.define('onsw-dropdown', class extends HTMLElement {
 *   constructor() {
 *     super();
 *     createDropdown(this);
 *   }
 * });
 * ```
 *
 * @param {Element} host
 */
export const createDropdown = (host) => onClickElement(host, click);
/**
 * @param {Element} clicked
 * @param {Element} host
 */
const click = (clicked, host) => closestAttribute(host, clicked, "data-show-popup", showDropdown);
/**
 * @param {string} id
 * @param {Element | null} trigger
 * @param {Element} host
 */
const showDropdown = async (id, trigger, host) => {
    DEBUG: console.debug(MODULE, { host, trigger });
    const selector = `[data-popup-id="${id}"]`;
    const available = queryInTemplates(host, selector);
    if (available) {
        const comment = createComment(selector);
        after(available, comment);
        try {
            await popup(host).show(available);
        }
        finally {
            replace(comment, available);
        }
    }
};
/*
 * @param {Element | null} container
 * @param {string} dropdownId
 *
const findInTemplates = (container, dropdownId) =>
  (container && queryInTemplates(container, `[data-popup-id="${dropdownId}"]`, "[data-popup-local]")) ??
  queryInTemplates(document, `[data-popup-id="${dropdownId}"]`, "[data-popup-global]");
 */
